/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_TitleInputs */

const he_contact_title = /** @type {(inputs: Contact_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`יצירת קשר`)
};

const en_contact_title = /** @type {(inputs: Contact_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact Us`)
};

/**
* | output |
* | --- |
* | "Contact Us" |
*
* @param {Contact_TitleInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const contact_title = /** @type {((inputs?: Contact_TitleInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_TitleInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_contact_title(inputs)
	return en_contact_title(inputs)
});